import { PartialUserErrors } from 'services/UserService/UserService';
import { ErrorMessages } from 'types/types';

export type CreditCardErrorCodes = {
  [key in keyof typeof errorCodeToFieldName]: string;
};

export const getErrorMsgObj = (error: ErrorMessages) => {
  const { errors } = error;
  const errorMsgObj: Omit<PartialUserErrors, 'credit_card'> & {
    credit_card: any;
  } = {
    credit_card: {},
  };

  if (!errors) {
    return errorMsgObj;
  }

  const entries = Object.entries<string>(errors);

  entries.forEach(([key, [firstMsg]]) => {
    let fieldKey = key;

    if (key === '_') {
      Object.entries(fieldErrorMessages).forEach(([key, value]) => {
        if (value.includes(firstMsg)) {
          fieldKey = key;
        }
      });
    }

    const creditCardErrorKeys = Object.keys(errorCodeToFieldName);

    if (!creditCardErrorKeys.includes(fieldKey)) {
      errorMsgObj[fieldKey as keyof PartialUserErrors] = firstMsg;
    }

    errorMsgObj.credit_card[
      errorCodeToFieldName[fieldKey as keyof CreditCardErrorCodes]
    ] = firstMsg;
  });

  return errorMsgObj;
};

//TODO: fill in the rest of the error messages as needed
// Workaround until backend sends error messages in a more consistent format
const fieldErrorMessages = {
  coupon: [
    'Invalid discount code',
    'Promo code not recognised',
    'Code not recognised',
    'Voucher code not recognised',
  ],
};

type CheckHasDialogueStepFields = {
  errorMsgObj: Record<string, string>;
  fieldList?: string[];
};

export const checkHasDialogueStepFields = ({
  errorMsgObj,
  fieldList = dialogue2Fields,
}: CheckHasDialogueStepFields) => {
  const errorFields = Object.keys(errorMsgObj);
  return errorFields.some(field => fieldList.includes(field));
};

const dialogue2Fields = ['coupon', 'email', 'city_id'];

// supported server side error codes
export const errorCodeToFieldName = {
  generic_decline: 'number',
  insufficient_funds: 'number',
  lost_card: 'number',
  stolen_card: 'number',
  expired_card: 'number',
  incorrect_cvc: 'number',
  processing_error: 'number',
  incorrect_number: 'number',
  card_declined: 'number',
  invalid_number: 'number',
  'credit_card.number': 'number',

  invalid_expiry_year: 'expiry.year',
  invalid_expiry_month: 'expiry.month',
  invalid_cvc: 'cvc',
};

export const errorKeyToFieldName = {
  coupon: 'referralCode',
  email: 'email',
  city_id: 'city',
  gift_voucher_code: 'voucher.code',
  gift_voucher_pin: 'voucher.pin',
  gift_voucher: 'voucher.code',
};
